var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-breadcrumb-wrapper"},[_c('div',{staticClass:"sticky-breadcrumb",class:{'sidebar-open' : _vm.sidebarIsOpen}},[_c('v-container',{attrs:{"fluid":"","py-0":""}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2008dc36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/sticky-breadcrumb.vue
// module id = null
// module chunks = 